// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1UJNr","topBottomGutter":"Layout_topBottomGutter__1qTY0"};